/**
 * Shortcut for `typeof SOMETHING === "string"`.
 *
 * @param  {any} str input value
 * @returns {boolean} the query result
 */
const isString = (str) => typeof str === 'string';
export default isString;
